/* ET - Bestseller Slider — Swiper init (curated product cards, arrows + draggable scrollbar)

   Swiper ships with the theme as et-swiper.min.js, loaded just before this file, so both are deferred and
   execute in document order. Init is scoped per section root, which is what lets several Bestseller Slider
   sections stack on one page and each drive its own arrows and scrollbar. */

(function () {
  'use strict';

  if (window.__etBestsellerSliderInit) return;
  window.__etBestsellerSliderInit = true;

  /* In the theme editor a section can be injected after the deferred bundle has already run, and on a cold
     first paint the bundle may not have executed yet — cover both without assuming an order. */
  function whenSwiperReady(cb) {
    if (window.Swiper) {
      cb();
      return;
    }

    var vendor = document.querySelector('script[src*="et-swiper.min.js"]');
    if (vendor) {
      vendor.addEventListener('load', cb, { once: true });
      return;
    }

    var tries = 0;
    var timer = setInterval(function () {
      if (window.Swiper) {
        clearInterval(timer);
        cb();
      } else if (++tries > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  function buildOptions(root) {
    return {
      /* Slide widths live in CSS per breakpoint so the mobile card keeps its fixed 267px width and its
         peek of the next card, exactly as drawn. */
      slidesPerView: 'auto',
      spaceBetween: 8,
      speed: 450,
      grabCursor: true,
      watchOverflow: true,
      threshold: 4,
      observer: true,
      observeParents: true,
      a11y: Object.assign({ enabled: true }, window.etSwiperA11y),
      navigation: {
        prevEl: root.querySelector('[data-et-bs-prev]'),
        nextEl: root.querySelector('[data-et-bs-next]')
      },
      /* Scrollbar rather than pagination dots: the design shows a 48px thumb in a 128px track, i.e. the
         visible-slide ratio. */
      scrollbar: {
        el: root.querySelector('[data-et-bs-scrollbar]'),
        draggable: true,
        dragSize: 'auto',
        hide: false
      },
      breakpoints: {
        750: { spaceBetween: 16 }
      }
    };
  }


  /* Colour swatches: clicking one shows that colour - swaps the image, price, colour label and the links
     to that colour's variant. Delegated per section root so slides added later still work. */
  function bindSwatches(root) {
    if (root.dataset.etSwatchInit === 'true') return;
    root.dataset.etSwatchInit = 'true';

    root.addEventListener('click', function (event) {
      var swatch = event.target.closest('[data-et-bs-swatch]');
      if (!swatch || !root.contains(swatch)) return;

      var card = swatch.closest('[data-et-bs-card]');
      if (!card) return;

      card.querySelectorAll('[data-et-bs-swatch]').forEach(function (other) {
        other.classList.remove('et-bs-card__swatch--selected');
        other.setAttribute('aria-pressed', 'false');
      });
      swatch.classList.add('et-bs-card__swatch--selected');
      swatch.setAttribute('aria-pressed', 'true');

      var label = card.querySelector('[data-et-bs-color]');
      if (label) label.textContent = swatch.dataset.color;

      var image = card.querySelector('.et-bs-card__image');
      if (image && swatch.dataset.image) {
        image.srcset = swatch.dataset.imageSrcset || '';
        image.src = swatch.dataset.image;
      }

      var price = card.querySelector('[data-et-bs-price]');
      if (price) {
        /* Rebuild with the same sr-only labels the server rendered, so the swap keeps its
           screen-reader context instead of leaving two bare numbers. */
        var onSale = !!swatch.dataset.compare;
        var saleLabel = onSale ? price.dataset.saleLabel : price.dataset.regularLabel;
        var html =
          '<span class="et-bs-card__price-sale"><span class="sr-only">' +
          saleLabel + '</span>' + swatch.dataset.price + '</span>';
        if (onSale) {
          html +=
            '<span class="et-bs-card__price-compare"><span class="sr-only">' +
            price.dataset.regularLabel + '</span>' + swatch.dataset.compare + '</span>';
        }
        price.innerHTML = html;
      }

      var variantUrl = swatch.dataset.variantUrl || card.dataset.productUrl;
      var available = swatch.dataset.available === 'true';

      var button = card.querySelector('[data-et-bs-button]');
      if (button) {
        button.textContent = available ? card.dataset.buttonLabel : card.dataset.soldOutLabel;
        button.classList.toggle('et-bs-card__button--disabled', !available);
        if (available) {
          button.removeAttribute('aria-disabled');
          button.setAttribute('href', variantUrl);
        } else {
          button.setAttribute('aria-disabled', 'true');
          button.removeAttribute('href');
        }
      }

      card.querySelectorAll('[data-et-bs-link]').forEach(function (link) {
        link.setAttribute('href', variantUrl);
      });
    });
  }

  function init(root) {
    bindSwatches(root);

    var el = root.querySelector('[data-et-bs-swiper]');
    if (!el || el.dataset.etInit === 'true') return;
    el.dataset.etInit = 'true';

    whenSwiperReady(function () {
      root.etSwiper = new Swiper(el, buildOptions(root));
    });
  }

  /* The section wrapper itself carries .et-bestseller-slider (schema `class`), and shopify:section:load
     hands us that very element — querySelectorAll only walks descendants, so the scope must be tested too
     or the slider never initialises after a theme-editor edit. */
  function boot(scope) {
    var root = scope || document;
    if (root.matches && root.matches('.et-bestseller-slider')) init(root);
    root.querySelectorAll('.et-bestseller-slider').forEach(init);
  }

  function teardown(scope) {
    var root = scope || document;
    var destroy = function (el) {
      if (el.etSwiper) {
        el.etSwiper.destroy(true, true);
        el.etSwiper = null;
      }
    };
    if (root.matches && root.matches('.et-bestseller-slider')) destroy(root);
    root.querySelectorAll('.et-bestseller-slider').forEach(destroy);
  }

  if (document.readyState !== 'loading') {
    boot();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    teardown(event.target);
  });
})();
